import { useGet } from "@albertine/api-client";
import type { Supplier } from "@albertine/types/openapi";

export function useSuppliers() {
    return useGet(
        "suppliers",
        {},
        {
            select: (data: { results: Supplier[] }) => data.results,
        },
    );
}
